import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3ffafb65&scoped=true"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"
import style0 from "./style.scss?vue&type=style&index=0&id=3ffafb65&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffafb65",
  null
  
)

export default component.exports